
import { useState, useEffect, useCallback } from 'react';
import API from '../api/api';
import useSignOut from 'react-auth-kit/hooks/useSignOut';

const useGetSemesters = (role) => {

    const [semesters, setList] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    const fetchData = useCallback(async () => {
        try {
            const request = await API.get('/get_semesters');
            if (request.data.data) {
                setList(request.data.data);
            } 
        }
        catch(error) {
            if (error?.status === 401) {
                return;
              }
              if (error.status === 403) {return;} 
            setError(error);
        }
        finally {
            setLoading(false);
        }
    }, [role])


    useEffect(() => {
        fetchData();
    }, [fetchData]) 
    
    return { semesters, loading, error, refetch: fetchData };
}

export default useGetSemesters;